export const getCookieSecurityAttributes = (protocol) => (protocol === 'https:' ? '; SameSite=None; Secure' : '; SameSite=Lax');

export default (name, value, days) => {
  let expires = '';

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toGMTString()}`; // eslint-disable-line i18next/no-literal-string
  } else {
    expires = '';
  }

  const protocol = typeof window !== 'undefined' ? window.location?.protocol : '';
  const securityAttributes = getCookieSecurityAttributes(protocol);

  document.cookie = `${name}=${value}${expires}; path=/${securityAttributes}`; // eslint-disable-line i18next/no-literal-string
};
